import { Store } from 'redux';
import { IState } from '../../../store';
import { hideStalkerBanner, showStalkerBanner } from '../actions/stalkerBanner';
import { STALKER_BANNER_COOKIE } from './setStalkerBannerCookie';

export function runStalkerBanner(store: Store<IState>) {
  const cookieRegex = new RegExp(STALKER_BANNER_COOKIE, 'ig');

  if (cookieRegex.test(window.document.cookie)) {
    store.dispatch(hideStalkerBanner());
  } else {
    store.dispatch(showStalkerBanner());
  }
}
